import { CtrlCollection } from '@yuigoto/ctrl';
import Styles from 'components/admin/Campaigns.module.scss';
import { Delete } from 'components/elements/file/Delete';
import { Col } from 'components/grid/Col';
import { Row } from 'components/grid/Row';
import { Modal } from 'components/modal/Modal';
import { ControlRenderer } from 'components/renderers/ControlRenderer';
import { CampaignControl } from 'controls/CampaignControl';
import { ExecuteRequest } from 'core/glambox/GlamboxApi';
import { GlamboxEndpoints } from 'core/glambox/GlamboxEndpoints';
import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import { UiActions } from 'state/actions/UiActions';
import { PartnerAdminActions } from 'state/actions/user/PartnerAdminActions';
import { Utils } from 'utils/Utils';
import { FileHandler2 } from 'views/development/FileHandler2';
import { CampaignPeopleTable } from './PeopleCampaignTable';
import { CtrlType } from '@yuigoto/ctrl';

const ReceiptComponent = ({ receipts }) => {
  const [modal, setModal] = useState(false);
  if (!receipts || (receipts && receipts.length < 1)) return null;
  return (
    <>
      <Modal visible={modal} onCloseModal={() => setModal(!modal)}>
        <div>
          {receipts.map((item, key) => {
            return (
              <div key={key}>
                <img src={item.imageUrl} />
                <span>
                  Data de envio: {Utils.tempConvertDate(item.dateCreated)}
                </span>
              </div>
            );
          })}
        </div>
      </Modal>
      <button //className={"btn btn-sm btn-light-pink"}
        onClick={() => setModal(!modal)}
      >
        Ver comprovantes
      </button>
    </>
  );
};
export class CampaignDetailAdmin extends React.Component {
  constructor(props) {
    super(props);

    this.collection = new CtrlCollection();
    for (let i in CampaignControl) {
      if (Array.isArray(CampaignControl[i])) {
        let tempCollection = new CtrlCollection();

        for (let n in CampaignControl[i]) {
          tempCollection.add(CampaignControl[i][n]);
        }

        this.collection.collection.push(tempCollection);
      } else {
        this.collection.add(CampaignControl[i]);
      }
    }

    this.state = {
      campaign: null,
      members: [],
      memberStatus: [],
      statusList: [],
      campaignProducts: [],
      paymentTypes: [],
      productVariantIds: null,
      products: [],
      commision: null,
      campaignStatus: null,
      campaignProject: null,
      confirmDeleteModalIsVisible: false,
    };
  }

  componentDidMount() {
    const { history, person } = this.props;

    this.props.isAdmin(person.data.person.username, response => {
      const isAdmin = response.result;
      if (!isAdmin) {
        history.push('/');
      }
    });

    this.getMemberStatusList();
    this.getPaymentTypes();

    this.getCampaign();
  }

  renderChallengeField = paymentType => {
    const isChallengeType = paymentType === 12;

    const mainVideo = this.collection.get('mainVideo');
    const firstTutorialVideo = this.collection.get('firstTutorialVideo');
    const secondTutorialVideo = this.collection.get('secondTutorialVideo');
    const thirdTutorialVideo = this.collection.get('thirdTutorialVideo');
    const bannerMobile = this.collection.get('bannerMobile');
    const bannerDesktop = this.collection.get('bannerDesktop');
    const rules = this.collection.get('rules');
    const resume = this.collection.get('resume');
    const product = this.collection.get('product');
    const description = this.collection.get('description');

    product.type = isChallengeType ? CtrlType.HIDDEN : CtrlType.DEFAULT;
    description.type = isChallengeType ? CtrlType.HIDDEN : CtrlType.DEFAULT;

    mainVideo.type = isChallengeType ? CtrlType.DEFAULT : CtrlType.HIDDEN;
    firstTutorialVideo.type = isChallengeType
      ? CtrlType.DEFAULT
      : CtrlType.HIDDEN;
    secondTutorialVideo.type = isChallengeType
      ? CtrlType.DEFAULT
      : CtrlType.HIDDEN;
    thirdTutorialVideo.type = isChallengeType
      ? CtrlType.DEFAULT
      : CtrlType.HIDDEN;
    bannerMobile.type = isChallengeType ? CtrlType.DEFAULT : CtrlType.HIDDEN;
    bannerDesktop.type = isChallengeType ? CtrlType.DEFAULT : CtrlType.HIDDEN;
    rules.type = isChallengeType ? CtrlType.TEXTAREA : CtrlType.HIDDEN;
    resume.type = isChallengeType ? CtrlType.TEXTAREA : CtrlType.HIDDEN;

    product.required = !isChallengeType;
    description.required = !isChallengeType;

    mainVideo.required = isChallengeType;
    bannerMobile.required = isChallengeType;
    bannerDesktop.required = isChallengeType;
    rules.required = isChallengeType;
    resume.required = isChallengeType;
  };

  getCampaignStatus = () => {
    ExecuteRequest(
      GlamboxEndpoints.Campaign.getStatus,
      null,
      'GET',
      { Authorization: this.props.token },
      null,
      response => {
        const { result, statusCode } = response;
        if (statusCode === 200) {
          this.setState(
            {
              campaignStatus: result.sort((a, b) => a.statusId - b.statusId),
            },
            () => this.renderStatusList()
          );
        }
      }
    );
  };

  getCampaign = async () => {
    const { match } = this.props;
    const campaignId = match.params.campaignId;

    await ExecuteRequest(
      GlamboxEndpoints.Campaign.getById,
      null,
      'GET',
      { Authorization: this.props.token },
      {
        campaignId,
      },
      response => {
        const { result, statusCode } = response;

        if (statusCode === 200) {
          let { dateFrom, dateTo, finishDate } = result.campaign;

          if (dateFrom !== null) {
            let date = new Date(result.campaign.dateFrom);
            result.campaign.dateFrom = date.toLocaleDateString('pt-BR');
          }
          if (dateTo !== null) {
            let date = new Date(result.campaign.dateTo);
            result.campaign.dateTo = date.toLocaleDateString('pt-BR');
          }
          if (finishDate !== null) {
            let date = new Date(result.campaign.finishDate);
            result.campaign.finishDate = date.toLocaleDateString('pt-BR');
          }

          this.renderChallengeField(result.campaign?.paymentTypeId);
          this.setState(
            {
              campaign: result.campaign,
              members: result.members.members,
              campaignStatus: result.status,
              campaignProducts: result.products,
              campaignProject: result.project,
            },
            () => {
              this.getCampaignStatus();
            }
          );
        }
      }
    );
  };

  getMemberStatusList = () => {
    ExecuteRequest(
      GlamboxEndpoints.Campaign.getStatusMember,
      null,
      'GET',
      { Authorization: this.props.token },
      null,
      response => {
        const { result, statusCode } = response;

        if (statusCode === 200) {
          let status = result.map(s => {
            return s.statusName;
          });

          this.setState({
            memberStatus: status,
          });
        }
      }
    );
  };

  renderPaymentTypeList = () => {
    let { paymentTypes } = this.state;
    if (!paymentTypes) return null;

    let paymentTypeControl = this.collection.get('influencerPaymentTypeId'),
      opts = [];
    for (let paymentType of paymentTypes) {
      opts.push({
        name: `${
          paymentType.influencerPaymentTypeId
        } - ${paymentType.description.trim()}`,
        value: paymentType.influencerPaymentTypeId,
      });
    }

    paymentTypeControl.options = opts;
    paymentTypeControl.onChange = (_, value) => {
      let paymentTypeControl = this.collection.get('paymentDescription');
      let comission = null;
      let paymentType = null;

      for (let payment of paymentTypes) {
        if (payment.influencerPaymentTypeId === parseInt(value)) {
          comission = payment.value;
          paymentType = parseInt(value);
        }
      }

      paymentTypeControl.value = paymentType.description || null;

      let paymentTypeComissionControl = this.collection.get('value');
      paymentTypeComissionControl.value = comission;

      this.renderChallengeField(value);
      this.forceUpdate();
    };
    this.forceUpdate();

    this.setCampaignValues();
  };

  renderStatusList = () => {
    let { campaignStatus, campaign } = this.state;
    if (!campaign) return null;

    let statusTotais = {};

    for (let status of campaignStatus) {
      statusTotais[status.statusId] = status.statusName.trim();
    }
    this.setState(
      {
        statusList: statusTotais,
      },
      () => {
        let statusControl = this.collection.get('statusId'),
          opts = [];
        for (let status of campaignStatus) {
          opts.push({
            name: `${status.statusId} - ${status.statusName.trim()}`,
            value: status.statusId,
          });
        }

        statusControl.options = opts;
        statusControl.onChange = (evt, value) => {
          let statusIdControl = this.collection.get('statusName');
          const statusName = campaignStatus.find(item => {
            return item.statusId === parseInt(value);
          });
          statusIdControl.value = statusName.statusName || null;
          this.forceUpdate();
        };
        this.forceUpdate();
      }
    );

    this.setCampaignValues();
  };

  setCampaignValues = () => {
    const { campaign, paymentTypes } = this.state;
    if (!campaign) return null;

    for (let i in CampaignControl) {
      if (Array.isArray(CampaignControl[i])) {
        for (let n in CampaignControl[i]) {
          const tempCtrl = this.collection.get(CampaignControl[i][n].name);

          if (
            campaign.challengeCampaign &&
            (campaign.challengeCampaign[CampaignControl[i][n].alias] ||
              campaign.challengeCampaign[CampaignControl[i][n].name])
          ) {
            tempCtrl.value =
              campaign.challengeCampaign[CampaignControl[i][n].alias] ||
              campaign.challengeCampaign[CampaignControl[i][n].name];
          } else {
            tempCtrl.value =
              campaign[CampaignControl[i][n].alias] ||
              campaign[CampaignControl[i][n].name];
          }
        }
      } else {
        let name = CampaignControl[i].name;
        let alias = CampaignControl[i].alias;

        const temp = this.collection.get(name);

        if (
          campaign.challengeCampaign &&
          (campaign.challengeCampaign[CampaignControl[alias]] ||
            campaign.challengeCampaign[CampaignControl[name]])
        ) {
          temp.value =
            campaign.challengeCampaign[CampaignControl[alias]] ||
            campaign.challengeCampaign[CampaignControl[name]];
        } else {
          temp.value =
            campaign[CampaignControl[alias]] || campaign[CampaignControl[name]];
        }
      }
    }

    let comission = this.collection.get('value');
    let currentPaymentTypeId = this.collection.get(
      'influencerPaymentTypeId'
    ).value;

    console.log(currentPaymentTypeId);

    let currentPaymentType = paymentTypes.find(payment => {
      return payment.influencerPaymentTypeId === currentPaymentTypeId;
    });

    comission.value = currentPaymentType.value;
  };

  renderFilesUpload = () => {
    const { match } = this.props;
    const campaignId = match.params.campaignId;
    const { campaign } = this.state;

    let uploadUrl = `${process.env.REACT_APP_GB_API_ROOT}${GlamboxEndpoints.Campaign.uploadFile.url}/${campaignId}`;

    let uploadCampaignImg = (
      <>
        <p>Imagem da campanha:</p>
        <FileHandler2
          token={this.props.token}
          finish={this.finish}
          uploadUrl={uploadUrl}
        />
      </>
    );

    let uploadBriefing = (
      <>
        <p>Briefing:</p>
        <FileHandler2
          token={this.props.token}
          fields={{
            campaignId: campaignId,
          }}
          uploadUrl={uploadUrl}
          finish={this.finish}
        />
      </>
    );

    return (
      <>
        {campaign && campaign.urlImg && this.renderImg(campaign.urlImg)}
        {campaign && campaign.urlFile && this.renderFile(campaign.urlFile)}

        {campaign && !campaign.urlImg && uploadCampaignImg}
        {campaign && !campaign.urlFile && uploadBriefing}
      </>
    );
  };

  finish = updatedCampaign => {
    this.props.loaderShow();
    this.getCampaign();
    this.props.loaderHide();
    // if(updatedCampaign && updatedCampaign.length > 0){
    //   this.setState({
    //     campaign: Object.assign({}, this.state.campaign, updatedCampaign[0].result)
    //   });
    // }
  };

  onDeleteFinish = fileDeleted => {
    let updatedCampaign = this.state.campaign;
    if (updatedCampaign.urlFile === fileDeleted) {
      updatedCampaign.urlFile = null;
    } else if (updatedCampaign.urlImg === fileDeleted) {
      updatedCampaign.urlImg = null;
    }

    this.setState({
      campaign: updatedCampaign,
    });
  };

  renderFile = urlFile => {
    const { match } = this.props;
    const campaignId = parseInt(match.params.campaignId);

    let campaignUrl = [urlFile];

    return (
      <div>
        <a href={urlFile} target="_blank">
          briefing
        </a>

        <Delete
          files={campaignUrl}
          deleteUrl={GlamboxEndpoints.Campaign.deleteFile}
          fields={{ campaignId: campaignId, fileUrl: urlFile }}
          headers={{ Authorization: this.props.token }}
          onDeleteFinish={this.onDeleteFinish}
        />
      </div>
    );
  };

  renderImg = urlFile => {
    const { match } = this.props;
    const campaignId = parseInt(match.params.campaignId);

    let campaignUrl = [urlFile];

    return (
      <div className={Styles['upload-files']}>
        <div className="text-center">
          <figure>
            <img src={urlFile} />
          </figure>

          <Delete
            files={campaignUrl}
            deleteUrl={GlamboxEndpoints.Campaign.deleteFile}
            fields={{ campaignId: campaignId, fileUrl: urlFile }}
            headers={{ Authorization: this.props.token }}
            onDeleteFinish={this.onDeleteFinish}
          />
        </div>
      </div>
    );
  };

  renderCampaignApplicants = () => {
    const { members } = this.state;

    if (!members || members.length < 1) return null;
    const { match } = this.props;
    const campaignId = parseInt(match.params.campaignId);

    let applicants = members.filter(member => {
      return (
        member.member.influencerCampaignStatusId === 2 ||
        member.member.influencerCampaignStatusId === 3
      );
    });

    if (applicants.length > 0) {
      return (
        <CampaignPeopleTable
          data={this.getDisplayMembers(applicants)}
          columns={this.getHeaders()}
          title="Candidatas"
          token={this.props.token}
          campaignId={campaignId}
          callback={this.peopleStatusUpdated}
        />
      );
    } else {
      return <div>Não há Candidatas</div>;
    }
  };
  renderCampaignMembers = () => {
    const { members } = this.state;

    if (!members || members.length < 1) return null;

    let approvedMembers = members.filter(member => {
      return member.member.influencerCampaignStatusId > 3;
    });

    if (approvedMembers.length > 0) {
      const { match } = this.props;
      const campaignId = parseInt(match.params.campaignId);

      return (
        <CampaignPeopleTable
          data={this.getDisplayMembers(approvedMembers)}
          columns={this.getHeaders()}
          title="Participantes"
          token={this.props.token}
          campaignId={campaignId}
          callback={this.peopleStatusUpdated}
        />
      );
    } else {
      return <div>Não há participantes</div>;
    }
  };

  peopleStatusUpdated = membersUpdated => {
    const { members } = this.state;
    let newMembers = members;

    for (let member of newMembers) {
      for (let memberUpdated of membersUpdated) {
        if (memberUpdated.personId === member.member.personId) {
          Object.assign(member.member, memberUpdated);
        }
      }
    }

    this.setState({
      members: newMembers,
    });
  };

  getDisplayMembers = members => {
    const { campaignProject } = this.state;
    const project = {
      project: campaignProject,
    };
    let receipts = members.map((member, key) => {
      let newMember = { ...member.member };
      if (member.receipts) {
        newMember.receipts = [...member.receipts];
      }
      newMember = Object.assign({}, project, newMember);
      return newMember;
    });

    return receipts;
  };

  getHeaders = () => {
    let headers = [
      { title: 'Email', field: 'email', editable: 'never' },
      { title: 'Name', field: 'name', editable: 'never' },
      { title: 'PersonId', field: 'personId', editable: 'never' },
      {
        title: 'StatusId',
        field: 'influencerCampaignStatusId',
        editComponent: props => {
          const { memberStatus } = this.state;
          return this.renderStatusOptions(props, memberStatus);
        },
      },
      {
        title: 'Status Name',
        field: 'influencerCampaignStatusName',
        editable: 'never',
      },

      {
        title: 'Comprovantes',
        field: 'receipts',
        editable: 'never',
        render: rowData => {
          return <ReceiptComponent receipts={rowData.receipts} />;
        },
      },
      { title: 'Project', field: 'project', editable: 'never' },
    ];

    return headers;
  };

  getEditable = () => {
    let editable = {
      onRowUpdate: (newData, oldData) => {
        return new Promise((resolve, reject) => {
          const { members } = this.state;

          let dataUpdate = [...members];

          for (const n in dataUpdate) {
            if (dataUpdate[n].personId === newData.personId) {
              dataUpdate[n] = Object.assign({}, dataUpdate[n], newData);
            }
          }

          const payload = this.getUpdatePayload(newData, oldData);

          this.updateData(payload, () => {
            resolve();
          });
        });
      },
      onBulkUpdate: changes => {
        return new Promise((resolve, reject) => {
          this.updateBulk(changes, () => resolve());
        });
      },
    };
    return editable;
  };

  getPaymentTypes = async () => {
    await ExecuteRequest(
      GlamboxEndpoints.GlampartnerPaymentRegistry.getPaymentTypesDetail,
      null,
      'GET',
      {
        Authorization: this.props.token,
      },
      null,
      response => {
        const { result, statusCode } = response;
        if (statusCode === 200) {
          this.setState(
            {
              paymentTypes: result,
            },
            () => {
              this.renderPaymentTypeList();
            }
          );
        }
      }
    );
  };

  renderStatusOptions = (props, options) => {
    return (
      <select
        onChange={e => props.onChange(e.target.value)}
        value={props.value}
      >
        {(() => {
          return options.map((value, key) => {
            return (
              <option value={value} key={key}>
                {value}
              </option>
            );
          });
        })()}
      </select>
    );
  };

  getUpdatePayload = (newData, oldData) => {
    let payload = {
      status: newData.influencerCampaignStatusId,
      campaignId: oldData.campaignId,
      personId: oldData.personId,
    };

    return payload;
  };

  updateData = async (payload, callback) => {
    const token = this.props.token;

    let requestBody = {
      ...payload,
    };

    ExecuteRequest(
      GlamboxEndpoints.Campaign.updateMemberCampaignStatus,
      Object.assign({}, requestBody),
      'PUT',
      {
        Authorization: token,
      },
      null,
      response => {
        const { result, statusCode } = response;

        if (statusCode === 200) {
          let newMembers = [...this.state.members];
          for (let i in newMembers) {
            for (let j in result) {
              if (newMembers[i].member.personId === result[j].personId) {
                newMembers[i].member.influencerCampaignStatusIdId =
                  result[j].influencerCampaignStatusIdId;
                newMembers[i].member.influencerCampaignStatusId =
                  result[j].influencerCampaignStatusId;
              }
            }
          }

          this.setState({
            members: newMembers,
          });
        }
      }
    );

    callback();
  };

  updateBulk = (changes, callback) => {
    for (let n in changes) {
      let newData = changes[n].newData;
      let oldData = changes[n].oldData;

      const payload = this.getUpdatePayload(newData, oldData);
      this.updateData(payload, callback);
    }
  };

  onSubmit = e => {
    e.preventDefault();
    this.buildCampaignRequestBody(campaignRequestBody => {
      this.updateCampaign(campaignRequestBody);
    });
  };

  updateCampaign = async campaignRequestBody => {
    this.props.loaderShow();
    await ExecuteRequest(
      GlamboxEndpoints.Campaign.update,
      Object.assign({}, campaignRequestBody),
      'PUT',
      {
        Authorization: this.props.token,
      },
      null,
      response => {
        const { result, statusCode } = response;

        if (statusCode === 200) {
          this.props.successAlert('Campanha alterada com sucesso');
        } else {
          this.props.errorAlert(result.result.message);
        }

        this.props.loaderHide();
      }
    );
  };

  buildCampaignRequestBody = callback => {
    if (this.collection.validate()) {
      let campaignData = this.collection.toObject(true);
      campaignData.members = parseInt(campaignData.members) || 0;
      campaignData.paymentTypeId = parseInt(campaignData.paymentTypeId);

      let dateFrom = new Date(
        campaignData.dateFrom.split('/').reverse().join('-') + 'T00:00:00'
      );

      let dateTo = new Date(
        campaignData.dateTo.split('/').reverse().join('-') + 'T00:00:00'
      );
      let finishDate = new Date(
        campaignData.finishDate.split('/').reverse().join('-') + 'T00:00:00'
      );

      campaignData.dateFrom = dateFrom;
      campaignData.dateTo = dateTo;
      campaignData.finishDate = finishDate;
      campaignData.status = parseInt(campaignData.status);
      campaignData.campaignId = parseInt(this.props.match.params.campaignId);

      const isChallengeType = campaignData.paymentType === 12;
      if (isChallengeType) {
        campaignData.description = '';
        campaignData.product = '';
      }

      callback(campaignData);
    } else {
      this.forceUpdate();
    }
  };

  renderDeleteButton = () => {
    const { members } = this.state;

    if (!members || (members && members.length === 0)) {
      return (
        <button
          className={'btn btn-light-pink'}
          onClick={this.toggleDeleteCampaign}
        >
          apagar
        </button>
      );
    }
  };

  toggleDeleteCampaign = event => {
    event.preventDefault();

    const { members } = this.state;
    if (members && members.length > 0) {
      alert(
        'Existem candidatas e/ou participantes nessa campanha. Favor abrir um chamado pro TI'
      );
    } else {
      this.setState({
        confirmDeleteModalIsVisible: !this.state.confirmDeleteModalIsVisible,
      });
    }
  };

  deleteCampaignRequest = event => {
    event.preventDefault();
    this.props.loaderShow();
    const { match } = this.props;
    const campaignId = match.params.campaignId;
    ExecuteRequest(
      GlamboxEndpoints.Campaign.delete,
      null,
      'POST',
      {
        Authorization: this.props.token,
      },
      { campaignId },
      response => {
        const { result, statusCode } = response;

        if (statusCode === 200) {
          const { history } = this.props;
          history.push('/admin/campaigns/1');
        }
        this.props.loaderHide();
      }
    );
  };

  render() {
    return (
      <div className={'p-2 p-lg-5'}>
        <Helmet>
          <title>Admin Campanha : Campanha</title>
        </Helmet>
        <h1>Campanha</h1>

        <Row>
          <Col xs={12} md={6}>
            <div>
              <div className={'gb-contentblock p-4 level-2 mb-2'}>
                <form onSubmit={this.onSubmit}>
                  {ControlRenderer.renderCollection(this.collection)}
                  <button className={'btn btn-light-pink btn-md'}>
                    Alterar Dados
                  </button>
                </form>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6}>
            <div className={'gb-contentblock p-4 level-2 mb-2'}>
              {this.renderFilesUpload()}
            </div>
            <div>{this.renderDeleteButton()}</div>
          </Col>
        </Row>

        <Row>
          <Col xs={12}>
            <div>{this.renderCampaignApplicants()}</div>
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            <div>{this.renderCampaignMembers()}</div>
          </Col>
        </Row>

        <Modal
          visible={this.state.confirmDeleteModalIsVisible}
          onCloseModal={this.toggleDeleteCampaign}
        >
          <h3 className={'text-center mb-2'}>
            Deseja mesmo apagar esta campanha?
          </h3>
          <div className={Styles['btn-delete']}>
            <button
              className={'btn btn-sm btn-light-lime'}
              onClick={this.deleteCampaignRequest}
            >
              Sim
            </button>
            <button
              className={'btn btn-sm btn-light-pink'}
              onClick={this.toggleDeleteCampaign}
            >
              Não
            </button>
          </div>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  store: state,
  token: state.token.data.Authorization,
  person: state.person,
});

const mapDispatchToProps = dispatch => ({
  successAlert: message => {
    dispatch(UiActions.publishSuccessAlert(message));
  },
  errorAlert: message => {
    dispatch(UiActions.publishErrorAlert(message));
  },
  loaderShow: () => {
    dispatch(UiActions.loaderShow());
  },
  loaderHide: () => {
    dispatch(UiActions.loaderHide());
  },
  isAdmin: (email, callback) => {
    dispatch(PartnerAdminActions.isAdmin(email, callback));
  },
});

CampaignDetailAdmin = connect(
  mapStateToProps,
  mapDispatchToProps
)(CampaignDetailAdmin);
